module.exports = __webpack_public_path__ + "img/surveyEmoji1.727d0cb6.svg";